export default "__VITE_ASSET__3cb0250c__"